import script from "./performanceFund.vue?vue&type=script&setup=true&lang=js"
export * from "./performanceFund.vue?vue&type=script&setup=true&lang=js"

import "./performanceFund.vue?vue&type=style&index=0&id=3efb27c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3efb27c4"]])

export default __exports__